export default {
  subAreas: null,
  forbiddenAreas: null,

  selected: null,

  showSubAreaLabels: true,
  showForbiddenLabels: true
}
